import orders from './orders'
import template from './template'
import draft from './draft'
import price from './price'
import temporary from './temporary'
import batch from './batch'

export default {
  name: 'Order',
  path: 'order',
  meta: {
    label: 'order',
    auth: 'order'
  },
  component: {
    name: 'Order',
    render(c) {
      return c('router-view')
    }
  },
  children: [orders, template, draft, price, temporary, batch]
}
